import QuickBookConnect from './QuickBookConnect';

export default QuickBookConnect;
